export default {
	goHome: "Go back to home",
	message: "Nothing was found here...",
};
